module.exports = __webpack_public_path__ + "static/media/0049_Small.bf4de9ef.jpg";